import "./TabSet.css"

import { useState } from "react"
import classNames from "classnames"

import { Icon } from "web/components"

export default function TabSet({
  variant = "nav",
  tabs,
  selectedTabKey,
  onSelectTab,
}) {
  const [expanded, setExpanded] = useState(false)

  function selectItem(key) {
    onSelectTab(key)
    setExpanded(false)
  }

  // eslint-disable-next-line eqeqeq
  const menuTitle = tabs.find(({ key }) => key == selectedTabKey).label

  const tabClasses = classNames(`tab-set ${variant}`, {
    "menu-collapsed": !expanded,
  })
  return (
    <div className={tabClasses}>
      <div className="menu-title" onClick={() => setExpanded(!expanded)}>
        <div className="absolute left-0 top-0 ml-2 mt-2 text-white">
          <Icon name="bars-3" outline="true" width="25px" height="25px" />
        </div>

        {menuTitle}
      </div>
      {tabs.map(({ key, label }) => (
        <div
          id={`tab-${key}`}
          key={key}
          className={`tab ${variant} ${
            key.toString() === selectedTabKey ? "selected" : ""
          }`}
          onClick={() => {
            selectItem(key)
          }}
        >
          {label}
        </div>
      ))}
      {variant === "nav" && <div className="tab-spacer"></div>}
    </div>
  )
}
